import http from '@/utils/http'
import Api from '@/conf/Api';
import notify from '@/utils/notify'

// eslint-disable-next-line no-empty-pattern
export function LOAD_CITIES({ }, data) {
    return http.post(Api.cities.brasil, data)
}

export function LOAD_BANK({ commit }) {
    return http.post(Api.bank)
        .then((res) => {
            commit('SET_BANK', res.data);
        }).catch((e) => {
            notify(commit, e)
        })
}

// eslint-disable-next-line no-unused-vars
export async function LOAD_CEP({ commit }, cep) {
    let endereco = false
    let req;
    try {
        req = await fetch(Api.cep.replace('?', cep))
        endereco = await req.json()
    } catch (e) {
        // viacep falhou; cai pro opencep abaixo
    }
    if (!endereco) {
        req = await fetch(Api.opencep.replace('?', cep))
        endereco = await req.json()
    }
    /* if(endereco.erro)
        notify(commit, endereco)
    else */
    return endereco
    /* return http.get(Api.cep.replace('?', cep), {}).then(r => {
        if (r.data.erro) {
            commit('general/SET_STATUS', { text: 'CEP inválido', color: 'red' }, { root: true });
        }
        return r.data
    }).catch((e) => {
        notify(commit, e)
    }) */
}


export function UPDATE_PASS({ commit }, data) {
    return http.put(Api.pass, data).then(r => notify(commit, r)).catch((e) => {
        notify(commit, e)
    })
}

export function DISABLE_SUPPORTER_ACCOUNT({ commit }, data) {
    return http.delete(Api.supporter.disable, data).then(r => { r.data.msg = "Conta desativada com sucesso!"; notify(commit, r); window.location = Api.motivo }).catch((e) => notify(commit, e))
}

export function DISABLE_PENDENCY({ commit }) {
    return http.get(Api.disable_pendency).then(r => r.data).catch((e) => notify(commit, e))
}

export function LOAD_STATS({ commit, rootState }) {
    let url = rootState.user.usuario.perfil == 'agregado_doutor' ? Api.supporter.stats_aggregate : Api.supporter.stats;
    return http.get(url).then(r => {
        commit('SET_STATS', r.data)
    })
}

export function GET_COMMS({ rootState }) {
    if (rootState.user.usuario.perfil !== 'agregado_doutor')
        return http.post(Api.comm.getList, { valido: true }).catch(e => e.response)
}

// eslint-disable-next-line no-empty-pattern
export function GET_COMM({ }, id) {
    return http.get(Api.comm.get + id)
}

export function COMM_READED({ commit }, id) {
    http.put(Api.comm.get + id).then(r => {
        if (r.status == 200) commit('SET_COMM_READED', id);
    });
}

export function GET_RATE({ commit }, id) {
    return http.get(Api.vote + '/' + id).then(r => r.data).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function SET_RATE({ commit }, data) {
    return http.post(Api.vote, data).catch((e) => {
        notify(commit, e)
        return e
    })
}




